<!-- Breadcrumb for application -->
<div class="container">
    <nav aria-label="breadcrumb" class="breadCust">
        <ol class="breadcrumb">
            <li class="breadcrumb-item"><a routerLink="/corporate/home">Home</a></li>
            <li class="breadcrumb-item active" aria-current="page">Campaign Event Builder</li>
        </ol>
    </nav>
</div>
<div class="container mt-2 theme-fa-icon">
    <legend class="scheduler-border">
        <h5 class="font-weight-bold">Campaign Event Builder</h5>
    </legend>
    <fieldset class="scheduler-border">
        <div class="row">
            <div class="col-xl-4  col-md-6">
                <button class="cbtn mt-1" routerLink="/corporate/campaign-event-list">
                    <i class="bi bi-layout-sidebar blue-lt-icon" aria-hidden="true"></i>Events
                </button>
            </div>
           </div>
    </fieldset>
</div>